"use client";

import { c as _c } from "react/compiler-runtime";
import { selectorOptions, usePathname, useRouter } from "@opensea/navigation";
import { Button, Dropdown, DropdownItem, DropdownItemContent, DropdownItemTitle } from "@opensea/next-ui-kit";
import { Translate } from "@opensea/ui-kit/icons";
import { useTranslations } from "next-intl";
import { trackAction } from "@/lib/integrations/datadog";
import { MoreMenuItem, MoreMenuItemAvatar, MoreMenuItemContent, MoreMenuItemTitle } from "./MoreMenuItem";
export function MoreMenuLanguageItem(t0) {
  const $ = _c(25);
  let isSheet;
  let rest;
  if ($[0] !== t0) {
    ({
      isSheet,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = isSheet;
    $[2] = rest;
  } else {
    isSheet = $[1];
    rest = $[2];
  }
  const router = useRouter();
  const pathname = usePathname();
  const t = useTranslations("MoreMenuLanguageItem");
  if (isSheet) {
    let t1;
    if ($[3] !== pathname || $[4] !== router) {
      t1 = selectorOptions.map(option => <DropdownItem key={option.label} onClick={() => {
        trackAction("switch language", {
          value: option.locale
        });
        router.replace(pathname, {
          locale: option.locale
        });
      }}><DropdownItemContent><DropdownItemTitle>{option.label}</DropdownItemTitle></DropdownItemContent></DropdownItem>);
      $[3] = pathname;
      $[4] = router;
      $[5] = t1;
    } else {
      t1 = $[5];
    }
    let t2;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <Button icon={Translate} size="lg" variant="secondary" />;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    let t3;
    if ($[7] !== t) {
      t3 = t("title");
      $[7] = t;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    let t4;
    if ($[9] !== t3) {
      t4 = <MoreMenuItemContent><MoreMenuItemTitle>{t3}</MoreMenuItemTitle></MoreMenuItemContent>;
      $[9] = t3;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    let t5;
    if ($[11] !== rest || $[12] !== t4) {
      t5 = <MoreMenuItem isSheet={true} {...rest}>{t2}{t4}</MoreMenuItem>;
      $[11] = rest;
      $[12] = t4;
      $[13] = t5;
    } else {
      t5 = $[13];
    }
    let t6;
    if ($[14] !== t1 || $[15] !== t5) {
      t6 = <Dropdown content={t1}>{t5}</Dropdown>;
      $[14] = t1;
      $[15] = t5;
      $[16] = t6;
    } else {
      t6 = $[16];
    }
    return t6;
  }
  let t1;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <MoreMenuItemAvatar icon={Translate} />;
    $[17] = t1;
  } else {
    t1 = $[17];
  }
  let t2;
  if ($[18] !== t) {
    t2 = t("title");
    $[18] = t;
    $[19] = t2;
  } else {
    t2 = $[19];
  }
  let t3;
  if ($[20] !== t2) {
    t3 = <MoreMenuItemContent><MoreMenuItemTitle>{t2}</MoreMenuItemTitle></MoreMenuItemContent>;
    $[20] = t2;
    $[21] = t3;
  } else {
    t3 = $[21];
  }
  let t4;
  if ($[22] !== rest || $[23] !== t3) {
    t4 = <MoreMenuItem {...rest} data-testid="language">{t1}{t3}</MoreMenuItem>;
    $[22] = rest;
    $[23] = t3;
    $[24] = t4;
  } else {
    t4 = $[24];
  }
  return t4;
}